import { render, staticRenderFns } from "./video-section.vue?vue&type=template&id=530a371b&scoped=true&"
import script from "./video-section.vue?vue&type=script&lang=js&"
export * from "./video-section.vue?vue&type=script&lang=js&"
import style0 from "./video-section.vue?vue&type=style&index=0&id=530a371b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530a371b",
  null
  
)

export default component.exports